import { checkPermissions } from "components";

export default function useCanEditUser(userType, permissions) {
  return userType !== "sasi" ?
    checkPermissions(permissions, "users:update") :
    checkPermissions(permissions, "users:create:admins")  
}
